import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/_services/request.service';
import { authorityIds, operations, subAuthorities } from '@app/enums';

@Injectable({ providedIn: 'root' })
export class CoreApiService {
  private baseQry = {
    params: {},
    user_data: {
      authority: authorityIds.CORE,
      sub_authority: subAuthorities.GENERAL.CORE,
      operation: operations.LIST,
      data: 'NA',
      format: 'json',
    },
  };

  constructor(private REQ: RequestService) {}

  getCoreApiInfo(): Observable<any> {
    const qry = {
      params: { core_type: 'DAYCOUNT' },
      user_data: this.baseQry.user_data,
    };
    return this.REQ.get('core/info', { query: JSON.stringify(qry) });
  }

  getCoreApiAssetType(): Observable<any> {
    return this.REQ.get('core/asset_type', { query: JSON.stringify(this.baseQry) });
  }

  getCoreApiIndustryGroup(): Observable<any> {
    return this.REQ.get('core/industry_group', { query: JSON.stringify(this.baseQry) });
  }

  getCoreApiCurrency(): Observable<any> {
    return this.REQ.get('core/currency', { query: JSON.stringify(this.baseQry) });
  }

  getCoreApiCountry(): Observable<any> {
    return this.REQ.get('core/country', { query: JSON.stringify(this.baseQry) });
  }

  getCoreApiInstType(): Observable<any> {
    return this.REQ.get('core/inst_type', { query: JSON.stringify(this.baseQry) });
  }

  getAuthority(): Observable<any> {
    const qry = {
      params: {},
      user_data: {
        authority: authorityIds.ADMIN,
        sub_authority: subAuthorities.ADMIN.AUTHORITY,
        operation: operations.LIST,
        data: 'NA',
        format: 'json',
      },
    };
    return this.REQ.get('auth/authority', { query: JSON.stringify(qry) });
  }
}
